// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__3Tsby","table":"styles_table__22ggW","header":"styles_header__3-hg2"};